const _excluded = ["applicationId", "locationId", "children", "overrides"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as r from "react";
import { payments as k } from "../../node_modules/@square/web-sdk/dist/index.es.mjs";
import w from "../../components/error-screen/error-screen.es.mjs";
import { useDynamicCallback as b } from "../../hooks/use-dynamic-callback.es.mjs";
const i = /*#__PURE__*/r.createContext({
  cardTokenizeResponseReceived: null,
  createPaymentRequest: null,
  payments: null
});
function T(_ref) {
  let e = _ref.applicationId,
    o = _ref.locationId,
    u = _ref.children,
    l = _ref.overrides,
    n = _objectWithoutProperties(_ref, _excluded);
  const _r$useState = r.useState(),
    _r$useState2 = _slicedToArray(_r$useState, 2),
    a = _r$useState2[0],
    m = _r$useState2[1],
    _r$useState3 = r.useState(() => n.createPaymentRequest?.()),
    _r$useState4 = _slicedToArray(_r$useState3, 1),
    f = _r$useState4[0];
  r.useEffect(() => {
    const t = new AbortController(),
      s = t.signal;
    async function y(v) {
      await k(e, o, l).then(c => {
        if (c === null) throw new Error("Square Web Payments SDK failed to load");
        if (!v?.aborted) return m(c), c;
      });
    }
    return e && o && y(s), () => {
      t.abort();
    };
  }, [e, o]);
  const R = b(async t => {
    if (t.errors || !n.createVerificationDetails) {
      await n.cardTokenizeResponseReceived(t);
      return;
    }
    const s = await a?.verifyBuyer(String(t.token), n.createVerificationDetails());
    await n.cardTokenizeResponseReceived(t, s);
  });
  if (!e || !o) return /* @__PURE__ */r.createElement(w, null);
  if (!a) return null;
  const d = {
    cardTokenizeResponseReceived: R,
    createPaymentRequest: f,
    payments: a
  };
  return /* @__PURE__ */r.createElement(i.Provider, {
    value: d
  }, u);
}
const x = () => {
  const e = r.useContext(i);
  if (e === void 0) throw new Error("useForm must be used within a FormProvider");
  return e;
};
export { i as FormContext, T as default, x as useForm };